/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Weary_Tiger_SurgeInputs */

const fr_wild_weary_tiger_surge = /** @type {(inputs: Wild_Weary_Tiger_SurgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la mise à jour de la permission`)
};

/**

* @param {Wild_Weary_Tiger_SurgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wild_weary_tiger_surge = /** @type {((inputs?: Wild_Weary_Tiger_SurgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Weary_Tiger_SurgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wild_weary_tiger_surge(inputs)
});